import router from './router'
import store from './store'
import isHasRoute from './help/isHasRoute'
import { Message } from "element-ui"
const whiteList = ['Login', 'register', 'resetPassword', 'placeInfo', 'certificateInfo', 'examReportPDF', 'error', 'violationPhotos', 'uploadDocument', 'askExam']

router.beforeEach(async (to, from, next) => {
  // 1. 获取租户名
  const ots_tenant = window.localStorage.getItem('tenant');
  // 2. 获取登录用户信息
  let hasTaken = window.localStorage.getItem('userInfo');

  /* *** 解决输入地址无法复制问题 *** */
  // (1) 跳转路由_租户名_未改变, 用户信息_未丢失 => 正常跳转
  // (2) 跳转路由_租户名_未改变, 用户信息_丢失 => 登录页 保持原租户
  // (3) 跳转路由_租户名_改变, 不再考虑用户信息(清空) => 登录页 启用新租户
  // (4) 跳转路由_租户名_为null, 默认为租户名_未改变 => 保持原租户
  // (5) 无租户, 无用户名 => 登录页 新租户

  /***********************************************************************************
   * 保持当前租户 
   *  - localStorage_tenant 有值
   *  - localStorage_tenant 有值的前提, to.query.tenant 为空
   *  - localStorage_tenant 有值的前提, to.query.tenant 和 localStorage_tenant 相同
   ************************************************************************************/
  if ((ots_tenant && ots_tenant != 'undefined') && (!to.query.tenant || to.query.tenant == ots_tenant)) {

    // 3. 用户登录状态
    if (hasTaken && JSON.parse(hasTaken).id && JSON.parse(hasTaken).id.length > 0) {
      // 4. 获取用户信息
      const userInfo = JSON.parse(hasTaken)
      // 5. roleType : 1 教师 2 学生
      const { roleType } = userInfo
      // 6. 有用户信息, 登录页跳转首页
      if (to.path === '/login') {
        let planId = to.query.planId;
        window.sessionStorage.setItem("planId", planId);
        // 2023年11月22日 其他平台用户跳转
        if (userInfo.loginType) {
          next({ path: roleType == 2 ? planId ? "/stuHome/home" : "/stuHome/batch" : "/index" });
        } else {
          next({ path: roleType == 2 ? '/stuHome/home' : roleType == 5 ? '/review' : roleType == 6 ? '/signing' : '/index' })
        }

      } else {
        // 7. 判断权限, 配置 管理/学生 端路由
        const routesList = roleType == 2 ? 'stuRoutes' : 'permisson_routes'
        // 8. 判断路由是否成功加载
        const hasPermission = store.getters[routesList] && store.getters[routesList].length > 0
        // 9. hasPermission 只保证后台路由表已加载
        if (hasPermission) {
          // 10. 获取路由信息
          const routes = store.getters[routesList]
          // 11. 判断跳转的路由是否包含在路由信息集合中
          if (to.name && isHasRoute(to.name, routes)) {
            next()
          } else {
            // 12. 路由信息不包含将要跳转的路由, 报错(无权限)
            Message({
              message: '您没有该页面权限，请联系管理员配置',
              type: 'error',
              duration: 5 * 1000
            })
            // 13. 当访问路由无权限时, 重定位至首页
            next({ path: roleType == 2 ? '/stuHome/home' : roleType == 5 ? '/review' : roleType == 6 ? '/signing' : '/index' })

          }
        } else {
          // 14. 如果后台路由未加载
          try {
            const actionName = roleType == 2 ? 'permission/generateRoutes_Stu' : 'permission/generateRoutes';
            const accessRoutes = await store.dispatch(actionName);
            router.addRoutes(accessRoutes)
            // 15. 添加404
            router.addRoutes([
              {
                path: '/*',
                name: '404',
                hiddenMenu: true,
                meta: {
                  title: '页面错误'
                },
                component: () => import('@/views/404.vue')
              }
            ])
            next({ ...to, replace: true })
          } catch (error) {
            console.log(error)
          }
        }
      }
    } else {
      // 16. 没有用户信息, ( 未登录 / lose Cookie )
      if (whiteList.indexOf(to.name) !== -1) {
        // 17. 登录(Login) / 注册(register) / 重置密码(resetPassword) ==> 进入下一路由 
        next();
      } else {
        // 18. 其它: 进入登录页 (登录路由需处理)
        next({
          path: '/login',
          query: { tenant: window.localStorage.getItem('tenant') },
          replace: true
        })
      }
    }

    /***********************************************************************************
     * 启用新租户 (强制清空 localStorage_userInfo, jump Login)
     *  - localStorage_tenant 有值
     *  - to.query.tenant 和 localStorage_tenant 不相同
     *  - localStorage_tenant 没有值 ==> Login
     ************************************************************************************/
  } else if ((ots_tenant && ots_tenant != 'undefined' && ots_tenant != to.query.tenant) || (!ots_tenant || ots_tenant == 'undefined')) {
    // 1. 清空 localStorage_userInfo
    window.localStorage.clear('userInfo');
    // 2. 配置跳转地址的参数 tenant, 防止报错(not undefined);
    // if (to.query.tenant) {
    //   window.localStorage.setItem('tenant', to.query.tenant);
    // } else {
    //   window.localStorage.setItem('tenant', '');
    // }
    if (to.query.tenant) {
      window.localStorage.setItem('tenant', to.query.tenant);
    }
    // !! 如果是登录页, 需要页面重新渲染 (避免租户名为 undefined 无限刷新)
    // if (to.name == 'Login' && ((!ots_tenant || ots_tenant == 'undefined') && to.query.tenant || (ots_tenant && ots_tenant != 'undefined' && ots_tenant != to.query.tenant))) {
    if (to.name == 'Login' && (!ots_tenant && to.query.tenant || (ots_tenant && ots_tenant != 'undefined' && ots_tenant != to.query.tenant))) {
      to.query.refresh = true;
    }

    // 3. 登录(Login) / 注册(register) / 重置密码(resetPassword) ==> 进入下一路由 
    if (whiteList.indexOf(to.name) !== -1) {
      next();
    } else {
      next({
        path: '/login',
        query: { tenant: window.localStorage.getItem('tenant') },
        replace: true
      })
    }
  } else {
    console.log('Throw Router_BeforeEach Error');
  }
})

router.afterEach((to, from) => {
  window.document.title = (to.meta && to.meta.title) ? to.meta.title : '报名系统'
})

router.onError(function () {
  console.log('Throw Router_BeforeEach Error')
})


